import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import TopBar from '../../../lib/components/TopBar'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import { HOME } from '../../routing/paths'

const TopBarComponent = () => {
  useEffect(() => {
    topBarStore.setLogoUrl(HOME)
  }, [])

  return <TopBar topBarStore={topBarStore} />
}

export default observer(TopBarComponent)
